<div
  class="chart-container"
  style="position: relative; height:40vh; width:80vw"
>
  <canvas width="400" height="100"></canvas>
</div>

<script>
  import {Bar} from "vue-chartjs";
  import h from "../../../services/h";
  import constants from "../../../constants";
  import errorMessageFilter from "../../../filters/errorMessageFilter";
  import utils from "../../../services/utils";

  export default {
    extends: Bar,
    name: "tien-do-hoan-thanh-cv-chart",

    data() {
      return {
        chartData: {},
        options: {
          title: {
            display: false
          },
          tooltips: {mode: "index", intersect: false},
          responsive: true,
          aspectRatio: 2,
          scales: {
            xAxes: [{stacked: true}],
            yAxes: [{stacked: true}]
          }
        }
      };
    },

    // mounted() {
    //   this.renderChart(this.chartdata, this.options);
    // },

    methods: {
      /**
       * hàm này dùng để populate data;
       * @param reportData (trên service ánh xạ với class TienDoHoanThanhReport)
       * @returns {Promise<AxiosResponse<any> | void>}
       */
      loadData(reportData) {
        let userDeptRoles = reportData.userDeptRoleViews || [];
        userDeptRoles.sort((node1, node2) =>
          utils.compareUserDeptRoleView(node1, node2)
        );
        this.chartData = {
          labels: h.collect(userDeptRoles, item => item.fullName),
          datasets: h.collect(
            [
              constants.TIENDOHOANTHANHCV_REPORT.TYPE.TRUOC_HAN,
              constants.TIENDOHOANTHANHCV_REPORT.TYPE.DUNG_HAN,
              constants.TIENDOHOANTHANHCV_REPORT.TYPE.QUA_HAN
            ],
            type => {
              return {
                label: this.getLabelForType(type),
                backgroundColor: this.getBackgroundColor(type),
                data: h.collect(userDeptRoles, userDeptRole => {
                  let reportItem = h.find(
                    reportData.items,
                    reportItem_ =>
                      reportItem_.type === type &&
                      reportItem_.userDeptRoleId === userDeptRole.id
                  );
                  return reportItem ? reportItem.count : 0;
                })
              };
            }
          )
        };
        this.renderChart(this.chartData, this.options);
      },

      getLabelForType(type) {
        switch (type) {
          case constants.TIENDOHOANTHANHCV_REPORT.TYPE.TRUOC_HAN:
            return errorMessageFilter({
              errorCode: "tienDoHoanThanhCv.type.truocHan"
            });
          case constants.TIENDOHOANTHANHCV_REPORT.TYPE.DUNG_HAN:
            return errorMessageFilter({
              errorCode: "tienDoHoanThanhCv.type.dungHan"
            });
          case constants.TIENDOHOANTHANHCV_REPORT.TYPE.QUA_HAN:
            return errorMessageFilter({
              errorCode: "tienDoHoanThanhCv.type.quaHan"
            });
        }
      },

      getBackgroundColor(type) {
        switch (type) {
          case constants.TIENDOHOANTHANHCV_REPORT.TYPE.TRUOC_HAN:
            return "#39ca74"; //green
          case constants.TIENDOHOANTHANHCV_REPORT.TYPE.DUNG_HAN:
            return "#007aff"; //blue
          case constants.TIENDOHOANTHANHCV_REPORT.TYPE.QUA_HAN:
            return "#e54d42"; //red
        }
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/report/qlcv/tien-do-hoan-thanh-cv-chart.vue